//================= collection-left-sidebar.js and desktop-collection-sidebar.js =========

$(".collection-sidebar_links li span.collection-icon").click(function () {
  $(this).toggleClass("open");
  $(this).siblings("ul").slideToggle("slow");
});

$(".category-collection-sidebar .collection-sidebar_links li.active").parents("ul.child").css("display", "none");

$(".category-collection-sidebar .collection-sidebar_links li.active").parents("ul.child").parent("li").children("span.collection-icon").addClass("open");

$(".category-collection-sidebar .collection-sidebar_links li.active").parents("ul.grandchild").css("display", "none");

$(".category-collection-sidebar .collection-sidebar_links li.active").parents("ul.grandchild").parent("li").children("span.collection-icon").addClass("open");

$(".collection-desktop.category-collection-sidebar h4").click(function () {
  $(".collection-desktop.category-collection-sidebar h4 span.collection-icon").toggleClass("open");
  $(this).next("").slideToggle("");
});

//========== collection-sidebar.js =========
$(".sidebar_links li span.icon").click(function () {
  $(this).toggleClass("open");
  $(this).siblings("ul").slideToggle("slow");
});

$(".sidebar_list .sidebar_links li.active").parents("ul.child").css("display", "block");

$(".sidebar_list .sidebar_links li.active").parents("ul.child").parent("li").children("span.icon").addClass("open");

$(".sidebar_list .sidebar_links li.active").parents("ul.grandchild").css("display", "block");

$(".sidebar_list .sidebar_links li.active").parents("ul.grandchild").parent("li").children("span.icon").addClass("open");

$(".collection-page.sidebar_list h4").click(function () {
  $(".collection-page.sidebar_list h4 span.icon").toggleClass("open");
  $(this).next("").slideToggle("");
});

document.querySelector(".collection-icon-solution").addEventListener("click", function (event) {
    event.preventDefault();
    var target = document.querySelector(".collection-icon-solution");
    if (target.classList.contains("active")) {
      target.classList.remove("active");
    } else {
      target.classList.add("active");
    }
});